import {
  getGamesFeedAPI,
  getGamesSeoAPI,
  postGamesSeoAPI,
  putGamesSeoAPI,
  deleteGameSeoAPI,
  getOldGamesFeedAPI,
} from "../api";

export default {
  namespaced: true,

  state: {
    data: {
      games: null,
      gamesSeo: null,
      isLoading: false,
    },
  },

  getters: {
    getGamesList: (state) => state.data.games,
    getGamesSeoList: (state) => state.data.gamesSeo,
    getPromoLoading: (state) => state.data.isLoading,
  },

  actions: {
    actionGetGamesFeed({ commit, rootState }) {
      const { env } = rootState.selectEnv.data;
      return new Promise((resolve, reject) => {
        getGamesFeedAPI(env).then(
          (response) => {
            commit("SET_GAMES", response.data);
            resolve(response.data);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
      });
    },

    actionGetOldGamesFeed({ commit }) {
      return new Promise((resolve, reject) => {
        getOldGamesFeedAPI().then(
          (response) => {
            commit("SET_GAMES", response.data);
            resolve(response.data);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
      });
    },

    actionGetGamesSeo({ commit, rootState }) {
      commit("SET_IS_LOADING", true);
      const { env } = rootState.selectEnv.data;
      return new Promise((resolve, reject) => {
        getGamesSeoAPI(env).then(
          (response) => {
            setTimeout(() => {
              commit("SET_IS_LOADING", false);
            }, 1000);
            commit("SET_GAMES_SEO", response);
            resolve(response);
          },
          (error) => {
            console.log(error);
            setTimeout(() => {
              commit("SET_IS_LOADING", false);
            }, 1000);
            reject(error);
          }
        );
      });
    },

    actionSetGameSEO({ commit }, payload) {
      commit("SET_IS_LOADING", true);
      if (payload && !payload.Key) {
        return new Promise((resolve, reject) => {
          postGamesSeoAPI(payload)
            .then((res) => {
              resolve(res);
            })
            .catch((err) => {
              setTimeout(() => {
                commit("SET_IS_LOADING", false);
              }, 1000);
              console.log("err: ", err);
              reject(err);
            });
        });
      } else {
        return new Promise((resolve, reject) => {
          putGamesSeoAPI(payload)
            .then((res) => {
              resolve(res);
            })
            .catch((err) => {
              setTimeout(() => {
                commit("SET_IS_LOADING", false);
              }, 1000);
              console.log("err: ", err);
              reject(err);
            });
        });
      }
    },

    actionDeleteGameSEO({ commit }, payload) {
      commit("SET_IS_LOADING", true);
      return new Promise((resolve, reject) => {
        deleteGameSeoAPI(payload)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            setTimeout(() => {
              commit("SET_IS_LOADING", false);
            }, 1000);
            console.log("err: ", err);
            reject(err);
          });
      });
    },

    setGames({ commit }, payload) {
      commit("SET_GAMES", payload);
    },
    setGamesSeo({ commit }, payload) {
      commit("SET_GAMES_SEO", payload);
    },
  },

  mutations: {
    SET_GAMES(state, payload) {
      state.data.games = payload;
    },
    SET_GAMES_SEO(state, payload) {
      state.data.gamesSeo = payload;
    },
    SET_IS_LOADING(state, payload) {
      state.data.isLoading = payload;
    },
  },
};
